// extracted by mini-css-extract-plugin
export default {"company_content":"Company_company_content__8L9bN","section":"Company_section__wweLc","values_list":"Company_values_list__KWfGi","features_list":"Company_features_list__oTEak"};